<template>
  <v-main class="tpadding">
    <v-container fluid>
      <v-chip @click="back()" color="blueKonect" medium text class="pa-4 mb-2 white--text">Atras</v-chip>
      <v-card class="rounded-xl elevation-5">
        <v-toolbar dense dark color="pinkKonect" elevation="2">
          <v-toolbar-title>Reporte de no acceso</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn :disabled="items == 0" elevation="0" text small :loading="loading">
            <xlsx-workbook>
              <xlsx-sheet :collection="sheet.data" v-for="sheet in sheetsGeneral" :key="sheet.name" :sheet-name="sheet.name" />
              <xlsx-download :filename="'Reporte ' + this.reportTypeGeneral + '.xlsx'">
                <button>DESCARGAR</button>
                <v-icon right>mdi-microsoft-excel</v-icon>
              </xlsx-download>
            </xlsx-workbook>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row no-gutters class="mb-8">
            <v-col :cols="$vuetify.breakpoint.mobile ? 3 : 2">
              <v-dialog ref="dialogBegin" v-model="modalBegin" :return-value.sync="begin" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="begin" label="Fecha de inicio" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details class="pr-2"></v-text-field>
                </template>
                <v-date-picker v-model="begin" :min="this.allowedDates" scrollable locale="es">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalBegin = false"> Cancelar </v-btn>
                  <v-btn text color="primary" @click="$refs.dialogBegin.save(begin)"> Aceptar </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? 3 : 2">
              <v-dialog ref="dialogEnd" v-model="modalEnd" :return-value.sync="end" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="end" label="Fecha fin" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details class="pr-2"></v-text-field>
                </template>
                <v-date-picker v-model="end" :min="begin" scrollable locale="es">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalEnd = false"> Cancelar </v-btn>
                  <v-btn text color="primary" @click="$refs.dialogEnd.save(end)"> Aceptar </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? 3 : 2">
              <v-autocomplete v-model="turnSearch" @change="refresh()" :items="turnItem" label="Turno" prepend-icon="mdi-clock-outline" clearable :disabled="loading" hide-details></v-autocomplete>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? 3 : 3">
              <v-text-field class="pl-8" v-model="search" label="Buscar" single-line hide-details clearable></v-text-field>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? 6 : 3" right class="d-flex" style="justify-content: right">
              <v-btn :disabled="!isReading || begin === '' || end === ''" small center outlined color="blueKonect" class="mx-2 mt-auto" elevation="0" @click="refresh()">
                Consultar
                <v-icon right>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :search="search"
            :items-per-page="5"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              itemsPerPageAllText: 'Todos',
            }"
          >
            <template v-slot:[`item.message`]="{ item }">
              <span v-text="item.message" />
              <div :class="statusIconClass(item.code)"></div>
            </template>
            <template v-slot:[`footer.page-text`]="props">
              Página {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-data> No hay información disponible </template>
            <template v-slot:no-results> No se obtuvieron resultados </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right style="white-space: pre-line">
        {{ errorList[codeError] }}
        {{ "\n\n" + this.codeError }}
      </v-snackbar>
      <errormsg :onFinish="closeMsg" :show="error" :message="codeError" colorMsg="error" alignX="bottom" alignY="right" />
    </v-container>
  </v-main>
</template>

<script>
import services from "@/utils/services";
import { errormsg } from "@/components";
import moment from "moment";
import errorList from "@/utils/errorsList";
import { XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx";

export default {
  name: "Clientes",
  components: {
    errormsg,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data: () => ({
    loading: false,
    success: false,
    errorList,
    msgSuccess: "",
    codeError: "",
    code: "",
    begin: "",
    end: "",
    turnItem: [1, 2, 3, 4, 5, 6],
    turnSearch: "",
    modalBegin: false,
    modalEnd: false,
    allowedDates: "",
    error: false,
    sheetsGeneral: [],
    reportTypeGeneral: "",
    msgError: "",
    search: "",
    msgRemove: "¿Está seguro que desea desactivar al usuario?",
    headers: [
      {
        text: "Nombre de cliente",
        align: "center",
        sortable: true,
        value: "nombre_comercial",
      },
      {
        text: "Numero de nómina",
        align: "center",
        sortable: true,
        value: "numero_nomina",
      },
      {
        text: "Codigo Escaneado",
        align: "center",
        sortable: true,
        value: "referencia_empleado_ingresada",
      },
      {
        text: "Turno",
        align: "center",
        sortable: true,
        value: "turno_id",
      },
      {
        text: "Idruta",
        align: "center",
        sortable: true,
        value: "idruta",
      },
      {
        text: "Nombre de Ruta",
        align: "center",
        sortable: true,
        value: "nombre_ruta",
      },
      {
        text: "Tipo servicioidruta",
        align: "center",
        sortable: true,
        value: "tipo_servicio",
      },
      {
        text: "Fecha de inicio de viaje relacionado",
        align: "center",
        sortable: true,
        value: "fecha_inicio_plan",
      },
      {
        text: "Fecha de creación de log",
        align: "center",
        sortable: true,
        value: "fecha_creacion",
      },
      {
        text: "Estatus de acceso",
        align: "center",
        sortable: true,
        value: "message",
      },
    ],
    items: [],
    estados_viaje: {
      TRIP_NOT_EMPLOYEES_PROGRAM: "El viaje no tiene programa de empleados",
      USER_NOT_EMPLOYEES_PROGRAM_ROUTE_ACCESS: "El usuario no tiene acceso",
      REFERENCE_DOES_NOT_EXIST_IN_THE_EMPLOYEE_PROGRAM: "El código no se encuentra registrado",
      ASSOCIATED_TO_THE_CLIENT_BUT_NOT_ACCESS_TO_THE_ROUTE: "Intento de empleado sin acceso a ruta",
      USER_ALREADY_EXIST_IN_TRIP: "El empleado ya registró su abordaje en este viaje",
      RECORD_NOT_EXISTS: "El viaje está desactivado",
    },
  }),
  mounted() {
    if (this.isReading) {
      this.refresh();
      var dateFrom = moment(dateFrom).subtract(3, "months").format("YYYY-MM-DD");
      this.begin = moment().format("YYYY-MM-DD");
      this.end = moment().format("YYYY-MM-DD");
      this.allowedDates = dateFrom;
      this.refresh();
    }
  },
  computed: {
    isReading: function () {
      return services.check(1, this.$route.path);
    },
  },
  methods: {
    async refresh() {
      try {
        this.loading = true;
        let params = {
          data: {
            fecha_inicial: this.begin + "T00:00:00",
            fecha_final: this.end + "T23:59:59",
          },
        };
        // Peticion de Axios
        const {
          data: { data },
        } = await this.axios.post(services.routes.noAccess, params);

        // Comprueba si la variable turnSearch tiene algun turno y lo filtra, si no tiene te muestra todos.
        this.items = (this.turnSearch ?? "") === "" ? data : data.filter((item) => item.data.turno_id === this.turnSearch);

        // Se desestructura la respuesta para manejar un arreglo mas limpio y a primer nivel
        this.items = this.items.map(
          ({
            data: { referencia_empleado, numero_nomina, idruta, tipo_servicio, nombre_comercial, fecha_inicio_plan, nombre_ruta, turno_id, apellido_empleado },
            error: { code, message, data: { referencia_empleado_ingresada } },
            fecha_creacion,
          }) => ({
            referencia_empleado,
            apellido_empleado,
            referencia_empleado_ingresada,
            code,
            message:
              code === "USER_ALREADY_EXIST_IN_TRIP"
                ? message || this.estados_viaje[code]
                : this.estados_viaje[code],
            fecha_creacion: moment(fecha_creacion).format("DD-MM-YYYY HH:mm"),
            turno_id,
            numero_nomina,
            nombre_ruta,
            idruta,
            tipo_servicio,
            nombre_comercial,
            fecha_inicio_plan: moment(fecha_inicio_plan).format("DD-MM-YYYY HH:mm"),
          })
        );
        this.loading = false;

        // Xlsx
        this.reportTypeGeneral = "Reporte de no acceso";
        this.sheetsGeneral = [
          {
            name: "Reporte de no acceso",
            data: [{}],
          },
        ];
        if (this.items.length > 0) {
          this.sheetsGeneral[0].data.shift();
        }
        for (let i = 0; i < this.items.length; i++) {
          let obj = {
            "Nombre de cliente": this.items[i].nombre_comercial,
            "Numero de nómina": this.items[i].numero_nomina,
            "Codigo Escaneado": this.items[i].referencia_empleado,
            Turno: this.items[i].turno_id,
            Idruta: this.items[i].idruta,
            "Nombre de Ruta": this.items[i].nombre_ruta,
            "Tipo servicioidruta": this.items[i].tipo_servicio,
            "Fecha de inicio de viaje relacionado": this.items[i].fecha_inicio_plan,
            "Fecha de creación de log": this.items[i].fecha_creacion,
            "Estatus de acceso": this.items[i].message,
          };
          this.sheetsGeneral[0].data.push(obj);
        }
      } catch (error) {
        this.error = true;
        this.msgError = error.response?.data?.message || "Hubo un error.";
        this.codeError = error.response?.data?.code || "GENERAL_ERROR";
        this.loading = false;
      }
    },
    statusIconClass(code) {
      if (code === "ASSOCIATED_TO_THE_CLIENT_BUT_NOT_ACCESS_TO_THE_ROUTE") {
        return "circleIconYellow";
      }
      if (code === "USER_ALREADY_EXIST_IN_TRIP") {
        return "circleIconTeal";
      }
      return "circleIconRed";
    },
    closeMsg() {
      this.error = false;
    },
    back() {
      this.$router.push("/client/administracionPasajerosYViajes");
    },
  },
};
</script>

<style scoped>
.circleIconYellow {
  border-radius: 100px;
  border: 2px solid;
  width: 20px;
  margin: auto;
  background-color: #faee06;
  height: 20px;
  color: #757575;
}
.circleIconRed {
  border-radius: 100px;
  border: 2px solid;
  width: 20px;
  margin: auto;
  background-color: #fa0606;
  height: 20px;
  color: #757575;
}
.circleIconTeal {
  border-radius: 100px;
  border: 2px solid;
  width: 20px;
  margin: auto;
  background-color: #48acb9;
  height: 20px;
  color: #757575;
}
</style>
